import { useEffect, useState } from "react";
import config from "../config.js";

export default function CycleStatusView({ cycleId, loadInfo }) { 
   const [localLoadInfo, setLocalLoadInfo] = useState(loadInfo || null); // start as null
   
     const getPerformanceData = async () => {
       try {
         const response = await fetch(
           `${config.apiPath}/performance_process/performance_status_api.php`,
           {
             method: "POST",
             credentials: "include",
             headers: { "Content-Type": "application/json" },
             body: JSON.stringify({ cycle_id: cycleId }),
           }
         );
   
         const data = await response.json();
   
         if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
           window.location.href = `/${config.appPath}`;
         } else if (data.status === "success" && data.load_info) {
           setLocalLoadInfo(data.load_info);
         }
       } catch (error) {
         console.error(`Failed to fetch performance data for cycle ${cycleId}:`, error);
       }
     };
   
     // when parent sends initial data
     useEffect(() => {
       if (loadInfo) setLocalLoadInfo(loadInfo);
     }, [loadInfo]);
   
     // auto-refresh every 5 seconds
     useEffect(() => {
       const interval = setInterval(() => {
         if (document.visibilityState === "visible") {
           getPerformanceData();
         }
       }, 20000);
       return () => clearInterval(interval);
     }, [cycleId]);
   
     
     // safely extract data
     const percentage = Number(localLoadInfo?.percentage || 0);
     const display_percentage = Number(localLoadInfo?.display_percentage || 0);


  const steps = [
    { label: "Test Setup", start: 0, end: 20, process: loadInfo?.setup_process },
    { label: "AI Data", start: 20.1, end: 40, process: loadInfo?.ai_data_process },
    { label: "Title Check", start: 40.1, end: 60, process: loadInfo?.qc_process },
    { label: "Test Run", start: 60.1, end: 80, process: loadInfo?.cycle_process },
    { label: "Report", start: 80.1, end: 100, process: loadInfo?.report_process },
  ];

  const getSegmentColor = (step) => {
    if (percentage < step.start) return "bg-blue-200"; // Not Started
    if (percentage >= step.end) return "bg-blue-700"; // Done
    return "bg-blue-300"; // Started
  };

  function ProcessStatus({ process,percentage }) {
    let processType;

    if (process === "completed") {
      processType = "Done";
    } else if(process == 'started') {
      processType = percentage+'% completed';
    } else {
      processType='Not Started';
    }

    return <>{processType}</>;
  }
  return (
    <div className="rounded-md dark:border-white/20 mt-2">
            <div aria-hidden="true" className="mt-1">
        {/* Progress bar */}
        
        
        

         <div className="mb-2 grid grid-cols-5 text-sm font-medium text-gray-600 dark:text-gray-400">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`text-center ${percentage >= step.start ? "text-indigo-600 dark:text-indigo-400" : ""}`}
            >
              {step.label} - {" "}
              <ProcessStatus
                process={step.process}
                percentage={display_percentage.toFixed(1)}
              />
            </div>
          ))}
        </div>
        <div className="flex gap-2">
  {steps.map((step, index) => {
    let fill = 0;

    if (percentage >= step.end) fill = 100;
    else if (percentage > step.start)
      fill = ((percentage - step.start) / (step.end - step.start)) * 100;

    return (
      <div
        key={index}
        className="relative flex-1 h-3 rounded-md overflow-hidden bg-gray-200 dark:bg-white/10"
      >
        <div
          className={`${getSegmentColor(step)} transition-all duration-300`}
          style={{ width: `${fill}%`, height: "100%" }}
        />
      </div>
    );
  })}
</div>
      </div>
    </div>
  );
}
